'use client';
import dynamic from 'next/dynamic';

export const RouteLoadingSpinnerLazy = dynamic(
    () => import('./loading-spinner').then((mod) => mod.RouteLoadingSpinner),
    { ssr: false }
);
